import PropTypes from 'prop-types'
import Link from 'next/link'

import Typography from '../../typography'
import { getAuthor } from '../utils'
import { PROVIDERS_AUTHOR_NAME_MAP } from '../constants'

const Body = ({ course, ...attrs }) => {
  const author = getAuthor(course)
  const authorName = PROVIDERS_AUTHOR_NAME_MAP[course.provider] || (author && author.fullName ? author.fullName : 'El equipo Crehana')
  const courseUrl = course.provider === 'lachiripa'
    ? course.lachiripaCourseUrl
    : `/cursos/${course.id}/${course.meta.slug}`

  return <div
    className={'p-4'}>
    <Link
      href={courseUrl}>
      <a
        className={'block w-full mb-3'}
        style={{
          borderRadius: '0 1.5rem 1.5rem 1.5rem'
        }}
        target={course.provider === 'lachiripa' ? '_blank' : '_self'}>

        <Typography
          size={'four'}
          weight={'black'}
          clamp={2}
          style={{
            minHeight: '56px'
          }}>
          {course.title}
        </Typography>
      </a>
    </Link>
    <Typography
      size={'three'}
      weight={'regular'}>
      Por{' '}
      <Typography
        tag={'span'}
        size={'three'}
        weight={'medium'}>
        {authorName}
      </Typography>
    </Typography>
    {course.provider === 'crehana' && (
      <Typography
        size={'three'}
        weight={'regular'}
        className={'mt-2 flex items-center'}>
        <span style={{
          backgroundColor: '#10B981',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: 'bold',
          marginLeft: '8px'
        }}>GRATIS</span>
      </Typography>
    )}
  </div>
}

Body.propTypes = {
  course: PropTypes.object
}

export default Body
